import { FieldError } from "common/components/forms/FieldError";
import { useRandomId } from "common/hooks/useRandomId";
import React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import { Label } from "./forms/Label";
import styles from "./Select.module.css";

export interface SelectOption {
  key: string;
  value: string;
  label: string;
}

export type SelectProps = {
  title?: string;
  options: SelectOption[];
  defaultValue?: string;
  fieldProps?: UseFormRegisterReturn;
  value?: string;
  onChange?(newValue: string): void;
  name?: string;
} & (
  | {
      fieldProps: UseFormRegisterReturn;
      value?: never;
      defaultValue?: never;
      onChange?: never;
      name?: never;
    }
  | {
      fieldProps?: never;
      defaultValue?: string;
      value?: string;
      onChange(newValue: string): void;
      name: string;
    }
);

export const Select: React.FC<SelectProps> = ({
  options,
  title,
  defaultValue,
  fieldProps,
  value,
  onChange,
  name,
}) => {
  const id = useRandomId();

  return (
    <>
      {title && <Label htmlFor={id} title={title} />}
      <select
        className={styles.select}
        id={id}
        defaultValue={defaultValue}
        {...(fieldProps ?? {
          value,
          onChange(e) {
            onChange(e.target.value);
          },
          name,
        })}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {fieldProps && <FieldError name={fieldProps.name ?? name ?? ""} />}
    </>
  );
};
